export class SchoolProgramPlacementDetails {
    SchoolProgramType: string;
    YearOfEntryCode: string;
    YearOfEntryDescription: string;
    WishToEnrolIec: boolean;
    IecStartTermCode: string;
    IecStartTermYear: number;
    IecDurationCode: string;
    StartTermCode: string;
    StartTermDescription: string;
    StartTermYear: number;
    DurationCode: string;
    Year12InNSW?: boolean;
    Year11InNSW?: boolean;
    FromTRP?: boolean;
    CompulsorySubject1Code: string;
    CompulsorySubject2Code: string;
    CompulsorySubject3Code: string;
    CompulsorySubject4Code: string;
    CompulsorySubject5Code: string;
    CompulsorySubject6Code: string;
    CompulsorySubject7Code: string;
    PreferredSchool1Id: string;
    PreferredSchool2Id: string;
    PreferredSchool3Id: string;
    HasASiblingEnrollingAtTheSameTime?: boolean;
    IsSiblingEnrolledInAustralia?: boolean;
    SiblingGivenName: string;
    SiblingFamilyName: string;
    SiblingPreferredName: string;
    SiblingDateOfBirth: string;
    SiblingSchoolName: string;
    SiblingStudentNumber: string;
    SiblingComments: string;
    IsEligibleForStudyAbroad: boolean;
    AgeInYears: number;
    Gender: string;
    IsStudentFromRegularCountry: boolean;
    EligibleYearOfEntries: string[];
    AllowAdditionalMessage: boolean;
}
